module.exports = __webpack_public_path__ + "img/card_informe_supervisados.307bf780.svg";